import { render, staticRenderFns } from "./2020-12.vue?vue&type=template&id=7dff9d26&scoped=true&"
import script from "./2020-12.vue?vue&type=script&lang=js&"
export * from "./2020-12.vue?vue&type=script&lang=js&"
import style0 from "./2020-12.vue?vue&type=style&index=0&id=7dff9d26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dff9d26",
  null
  
)

export default component.exports